import React, { memo, useEffect, useState } from 'react';
import { useResponsiveQueries } from '../../utils/constants';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';
import '../../styles/FadeEffect.css';

const IMAGES = {
  whiteCat: 'https://dti2k7ujq2xio.cloudfront.net/images/White-Cat.webp',
  totem: 'https://dti2k7ujq2xio.cloudfront.net/images/Totem.webp',
  leaves: 'https://dti2k7ujq2xio.cloudfront.net/images/Leaves-M.webp',
  leaf: 'https://dti2k7ujq2xio.cloudfront.net/images/Leaf2.webp',
  character: 'https://dti2k7ujq2xio.cloudfront.net/images/Char1.webp'
};

const preloadMainImage = () => {
  // Only preload the main character image as it's likely the LCP element
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = IMAGES.character;
  document.head.appendChild(link);
};

const HomeRow1 = () => {
  const { MOBILE_WIDTH, HEADER_MIN_WIDTH } = useResponsiveQueries();
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    preloadMainImage();
  }, []);

  const handleImageLoad = (imageName) => {
    setLoadedImages((prev) => ({ ...prev, [imageName]: true }));
  };

  return (
    <div
      className='home-row1-container'>
      {!HEADER_MIN_WIDTH && (
        <motion.img
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className={`image1 ${loadedImages.whiteCat ? 'loaded' : ''}`}
          src={IMAGES.whiteCat}
          alt='WhiteCat'
          decoding="async"
          onLoad={() => handleImageLoad('whiteCat')}></motion.img>
      )}
      {!MOBILE_WIDTH && (
        <motion.img
          variants={fadeIn("up", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className={`image2 ${loadedImages.totem ? 'loaded' : ''}`}
          src={IMAGES.totem}
          alt='Totem'
          decoding="async"
          onLoad={() => handleImageLoad('totem')}></motion.img>
      )}
      {MOBILE_WIDTH && (
        <img
          className={`image5 ${loadedImages.leaves ? 'loaded' : ''}`}
          src={IMAGES.leaves}
          alt='Leaves'
          decoding="async"
          onLoad={() => handleImageLoad('leaves')}
        />
      )}
      {!HEADER_MIN_WIDTH && (
        <motion.img
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className={`image3 ${loadedImages.leaf ? 'loaded' : ''}`}
          src={IMAGES.leaf}
          alt='Leaf'
          decoding="async"
          onLoad={() => handleImageLoad('leaf')}></motion.img>
      )}
      <motion.img
        variants={fadeIn("up", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0 }}
        className={`image4 ${loadedImages.character ? 'loaded' : ''}`}
        src={IMAGES.character}
        alt='Character 1'
        fetchpriority="high"
        decoding="async"
        onLoad={() => handleImageLoad('character')}></motion.img>
      <motion.div
        variants={fadeIn("down", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0 }}
        className='label'>
        <h1 className='row-title'>BEST WAYS TO SUCCESS</h1>
        <p className='row-subtitle'>Start Your Dream Now</p>
      </motion.div>
    </div>
  );
};

export default memo(HomeRow1);